import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import FlipCard from './FlipCard'
import Header from './global/Header'
import Footer from './global/Footer'
import Brain from './Brain/Brain'
import { universityData } from '../Data'
import lineConnectImg from '../images/Seeding Brains UI/line connect-01.png'
import fantaiImg from '../images/Seeding Brains UI/fantai.png'
import HTBDImg from '../images/Seeding Brains UI/HTBD-LEFT.png'
import HTBDRightImg from '../images/Seeding Brains UI/HTBD-RIGHT.jpeg'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../App.scss'
import '../assets/css/brain.css'
import VideoModal from './VideoModal'

const HomePage = () => {
  const [modalShow, setModalShow] = React.useState(true);
  useEffect(() => {
    if (localStorage.getItem('firstTime')) {
      setModalShow(false)
    } else {
      localStorage.setItem('firstTime', true)
    }
  }, []);
  window.onbeforeunload = function() {
    localStorage.clear();
  }
  return (
    <div>
      <VideoModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <Header />
      <div style={{ marginTop: 50, marginBottom: 100 }}>
        <Container>
          <div className='brain-title'>
            <h1>Explore the brain</h1>
          </div>
          <div className='hover-brain-container'>
            <Brain />
            <Row>
              <Col md={12} style={{ textAlign: 'center' }}>
                <div className='lineConnectImgContainer'>
                  <img src={lineConnectImg} height={'83px'} alt='' />
                  <div className='HTBDImgContainer'>
                    <Link to='/htbd'>
                      <img src={HTBDImg} height={'180px'} alt='' />
                    </Link>
                    <Link to='/crictics'>
                      <img
                        src={HTBDRightImg}
                        height={'166px'}
                        alt=''
                        style={{
                          borderRadius: '50%',
                          marginLeft: -50,
                        }}
                      />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <Row>
              <Col md={12} style={{ textAlign: 'center' }}>
                  <img src={fantaiImg} height={'100px'} alt='' />
              </Col>
            </Row>
          <Row>
            {universityData &&
              universityData.map((card) => (
                <div className='col-md-3' key={card.id}>
                  <FlipCard card={card} />
                </div>
              ))}
          </Row>
        </Container>
      </div>
      <Footer />
    </div>
  )
}
export default HomePage
